import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I am incredibly satisfied with my decision to join Fitclub and select the perfect plan and program. Thanks to FitFusion, I have successfully attained my desired physique, and I couldn't be happier! ",
    name: "MATHEW HENDRICKSON",
    status: "ENTREPRENEUR",
  },
  {
    image: image2,
    review:
      "FitFusion has revolutionized the way I coach, providing exceptional tools and resources that enhance my ability to help clients reach their fitness goals. ",
    name: "JOHN KEVIN",
    status: "COACH",
  },
  {
    image: image3,
    review:
      " FitFusion has transformed my fitness journey, providing me with unmatched support, motivation, and a community of like-minded individuals.",
    name: "FRANKLIN",
    status: "CUSTOMER",
  },
];
